export default {
    namespaced: true,
    state: {
        currentStockcountOverview: 'default',
        showStockcountPhotos: false,
        filters: {
            code: '',
            location: '',
            profileSupplierCode: '',
            profileDescription: '',
            stock: '-1',
            priceList: '',
            filterGroups: null,
            profileSubGroups: null,
            profileSuppliers: null,
        },
    },
    mutations: {},
    getters: {},
};
